import type { AppState, AppStateAction } from './types';
import type { Dispatch } from 'react';

import { createContext, useContext } from 'react';

export type AppContextType = {
  dispatch: Dispatch<AppStateAction>;
  state: AppState;
};

export const AppContext = createContext<AppContextType | undefined>(undefined);

export function useAppContext(): AppContextType {
  const appContext = useContext(AppContext);

  if (appContext === undefined) {
    throw Error('useAppContext must be used within AppProvider');
  }

  return appContext;
}
